module.exports = {
      id: "app-gallery-usage",
      viewBox: "0 0 161 48",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#app-gallery",
      toString: function () {
        return this.url;
      }
    }